import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClinicMedical, faCheckCircle, faDirections } from "@fortawesome/free-solid-svg-icons";
import styles from "./Landing.module.css";

const About = () => {
  const features = [
    "Modern facility with private treatment suites and dedicated advanced rehab gym",
    "Specialists in orthopedics, neurology, pediatric physiotherapy, and sports injury",
    "Active community wellness focus through regular posture workshops & support groups",
    "Mission: Enabling freedom of movement and pain-free living for every patient",
  ];

  return (
    <section className={styles.infoSection}>
      <div className={styles.infoGrid}>
        {/* Left: Clinic Photo Card */}
        <div className={styles.infoImageCard}>
          <img
            src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=800&q=80"
            alt="ReformMe Healthcare Gurugram Clinic Facility"
          />
        </div>

        {/* Right: Text Details */}
        <div className={styles.infoText}>
          <div className={styles.heroBadge}>
            <FontAwesomeIcon icon={faClinicMedical} />
            <span>GURUGRAM CLINIC</span>
          </div>

          <h3>ReformMe Health Care, Gurugram</h3>

          <p>
            ReformMe Health Care in Gurugram provides gold-standard physiotherapy, advanced spinal rehabilitation, and preventive ergonomics care. Our clinicians tailor individualized recovery plans using evidence-backed biomechanical techniques and empower patients through movement screening.
          </p>

          <ul className={styles.featureList}>
            {features.map((feat, idx) => (
              <li key={idx} className={styles.featureItem}>
                <FontAwesomeIcon icon={faCheckCircle} className={styles.featureIcon} />
                <span>{feat}</span>
              </li>
            ))}
          </ul>

          <div className={styles.highlightQuote}>
            Located in central Gurugram — easily accessible for office executives, athletes, senior citizens, and children.
          </div>
        </div>
      </div>

      {/* Bottom: Dedicated Map & Directions Section */}
      <div className={styles.clinicMapBottom}>
        <div className={styles.mapWrapFull}>
          <iframe
            title="ReformMe Healthcare Clinic Gurugram Location Pin"
            src="https://maps.google.com/maps?q=ReformMe+Health+Care+Gurugram&t=&z=16&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <a
          href="https://maps.app.goo.gl/BceojkZdVPpc89p16"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.directionsBtnFull}
        >
          <FontAwesomeIcon icon={faDirections} style={{ fontSize: "1.25rem", color: "#38a169" }} />
          <span>Open in Google Maps</span>
          <span style={{ fontSize: "0.85rem", color: "#94a3b8", fontWeight: 600 }}>ReformMe Location ↗</span>
        </a>
      </div>
    </section>
  );
};

export default About;
